import { Injectable } from '@angular/core';

import { Route } from '@bca-shared/models/_enums';
import { RouterService } from '@bca-core/services/router.service';
import { IRootState } from '@bca-store/store.reducers';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { CanActivate } from '@angular/router';

@Injectable()
export class AgreementGuard implements CanActivate {
  constructor(
    private _store$: Store<IRootState>,
    private _routerService: RouterService
  ) {}

  canActivate(): Observable<boolean> {
    return this._store$.pipe(
      select(({ receipt }) => receipt.company),
      take(1),
      map(company => company != null),
      tap((hasCompany: boolean) => {
        if (!hasCompany) {
          this._routerService.navigateTo(Route.COMPANY_DATA);
        }
      })
    );
  }
}
